import React from "react";
import {PageHeading} from "peggirkit";
import {Route} from "@/routing/Router";
import {FormattedMessage, useIntl} from "react-intl";
import LocationPageMeta from "@widgets/heading/meta/LocationPageMeta";
import MenuOverviewHeadingActions from "@widgets/menuEditor/menu/heading/MenuOverviewHeadingActions";
import {generateBreadcrumbs} from "@widgets/layout/Breadcrumbs";

type Props = {
    route: Route,
    isFetching: boolean,
};

const MenuOverviewHeading = ({route, isFetching}: Props) => {
    const intl = useIntl();

    return (
        <div className={"flex flex-col gap-4"}>
            <PageHeading
                breadcrumbs={generateBreadcrumbs(route, intl)}
                title={intl.formatMessage(({id: "menuCard"}))}
                actionRowHorizontal={false}
                actionRow={<MenuOverviewHeadingActions isFetching={isFetching}/>}
                meta={<LocationPageMeta/>}
                breakpoints={{md: {actionRowHorizontal: true}}}
            />

            <p className={"w-full text-sm max-w-[600px] text-gray-500 dark:text-slate-400"}>
                <FormattedMessage id={"menuCard.description"}/>
            </p>
        </div>
    );
};

export default MenuOverviewHeading;